//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "ClassesItem",
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    isUnderlineLeft: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onItemClick: function onItemClick() {
      this.$router.push({
        name: "ClassesDetail",
        params: {
          id: this.item.id
        }
      });
    }
  }
};